export const home = {
  title: 'Choose a workspace',
  empty: 'No workspaces assigned',
};
